import { render, staticRenderFns } from "./the-add-type.vue?vue&type=template&id=c2828e5c&scoped=true&"
import script from "./the-add-type.vue?vue&type=script&lang=js&"
export * from "./the-add-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2828e5c",
  null
  
)

export default component.exports